import * as React from "react";
import Box from "@material-ui/core/Box";
import LinearProgress from "@material-ui/core/LinearProgress";
import { makeStyles } from "@material-ui/core";
import { tesaBlue, tesaBlue4 } from "../../styles/colors";

const useLinearProgressStyles = makeStyles({
  colorPrimary: {
    backgroundColor: tesaBlue4,
  },
  barColorPrimary: {
    backgroundColor: tesaBlue,
  },
});

interface LinearIndeterminateProps {
  loading: boolean;
}

export default function LinearIndeterminate(props: LinearIndeterminateProps) {
  const { loading } = props;
  return (
    <Box visibility={loading ? "visible" : "hidden"}>
      <LinearProgress classes={useLinearProgressStyles()} />
    </Box>
  );
}
